/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Phoenix | v1
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult
} from '@tanstack/react-query';

import type {
  ListRequest,
  ListResponseOfCodebookEntrySuggestion,
  ListResponseOfCurrencySuggestion
} from '.././schemas';

import { customInstance } from '../../customInstance';
import type { ErrorType } from '../../customInstance';




export const getCurrencySuggestions = (
    listRequest: ListRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<ListResponseOfCurrencySuggestion>(
      {url: `/api/codebooks/currencies`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: listRequest, signal
    },
      );
    }
  


export const getGetCurrencySuggestionsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getCurrencySuggestions>>, TError,{data: ListRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof getCurrencySuggestions>>, TError,{data: ListRequest}, TContext> => {

const mutationKey = ['getCurrencySuggestions'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getCurrencySuggestions>>, {data: ListRequest}> = (props) => {
          const {data} = props ?? {};

          return  getCurrencySuggestions(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type GetCurrencySuggestionsMutationResult = NonNullable<Awaited<ReturnType<typeof getCurrencySuggestions>>>
    export type GetCurrencySuggestionsMutationBody = ListRequest
    export type GetCurrencySuggestionsMutationError = ErrorType<unknown>

    export const useGetCurrencySuggestions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getCurrencySuggestions>>, TError,{data: ListRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getCurrencySuggestions>>,
        TError,
        {data: ListRequest},
        TContext
      > => {

      const mutationOptions = getGetCurrencySuggestionsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getCodebookEntrySuggestions = (
    listRequest: ListRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<ListResponseOfCodebookEntrySuggestion>(
      {url: `/api/codebooks/entries`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: listRequest, signal
    },
      );
    }
  


export const getGetCodebookEntrySuggestionsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getCodebookEntrySuggestions>>, TError,{data: ListRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof getCodebookEntrySuggestions>>, TError,{data: ListRequest}, TContext> => {

const mutationKey = ['getCodebookEntrySuggestions'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getCodebookEntrySuggestions>>, {data: ListRequest}> = (props) => {
          const {data} = props ?? {};

          return  getCodebookEntrySuggestions(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type GetCodebookEntrySuggestionsMutationResult = NonNullable<Awaited<ReturnType<typeof getCodebookEntrySuggestions>>>
    export type GetCodebookEntrySuggestionsMutationBody = ListRequest
    export type GetCodebookEntrySuggestionsMutationError = ErrorType<unknown>

    export const useGetCodebookEntrySuggestions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getCodebookEntrySuggestions>>, TError,{data: ListRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getCodebookEntrySuggestions>>,
        TError,
        {data: ListRequest},
        TContext
      > => {

      const mutationOptions = getGetCodebookEntrySuggestionsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    